<template>
  <el-drawer title="详情" :visible.sync="visible"  direction="rtl" size="40%" >
    <div class="drawer-main" v-loading="loading">
      <p class="title">基本信息</p>
      <el-form :model="detail" :size="size" ref="dataForm" label-position='right' label-width="160px" >
        <el-form-item label="合同名称">
          <span>{{ detail.name }}</span>
        </el-form-item>
        <el-form-item label="合同编号">
          <span>{{ detail.number }}</span>
        </el-form-item>
        <el-form-item label="服务提供方公司">
          <span>{{ detail.serviceProviderCompanyName }}</span>
        </el-form-item>
        <el-form-item label="服务提供方公司办理人">
          <span>{{ detail.serviceProviderTransactorNickname }}</span>
        </el-form-item>
        <el-form-item label="客户公司">
          <span>{{ detail.clientCompanyName }}</span>
        </el-form-item>
        <el-form-item label="客户公司办理人">
          <span>{{ detail.clientTransactorNickname }}</span>
        </el-form-item>
        <el-form-item label="合同状态">
          <span>{{ status.find(c => c.value == detail.status)["label"] }}</span>
        </el-form-item>
        <el-form-item label="签订时间">
          <span>{{ this.$moment(detail.signingTime).format('YYYY/MM/DD') }}</span>
        </el-form-item>
        <el-form-item label="起止时间">
          <span>{{ this.$moment(detail.startTime).format('YYYY/MM/DD') }} - {{ this.$moment(detail.endTime).format('YYYY/MM/DD') }}</span>
        </el-form-item>
      </el-form>
      <p class="title">关联项目信息</p>
      <div class="project" v-for="item in projects" :key="item.projectId">
        <el-form :size="size" label-position='right' label-width="160px" >
          <el-form-item label="项目名称">
            <span>{{ item.projectName }}</span>
          </el-form-item>
          <el-form-item label="项目编号">
            <span>{{ item.projectNumber }}</span>
          </el-form-item>
          <el-form-item label="类型">
            <span>{{ item.specificationType ? taskList.find((c) => c.value == item.specificationType)["label"] : '' }}</span>
          </el-form-item>
          <el-form-item label="周期" v-if="item.specificationType === 3 || item.specificationType === 4">
            <span>{{ item.cycle ? cycleList.find((c) => c.value == item.cycle)["label"] : '' }}</span>
          </el-form-item>
          <el-form-item label="次数">
            <span>{{ item.times }} 次</span>
          </el-form-item>
          <el-form-item label="服务区域">
            <span>{{ item.regionName }}</span>
          </el-form-item>
          <el-form-item label="关联设备">
            <div class="tree-content">
              <el-tree
                :data="treeData"
                show-checkbox
                default-expand-all
                node-key="measureId"
                ref="tree"
                highlight-current
                :props="defaultProps">
              </el-tree>
            </div>
          </el-form-item>
          <el-form-item label="联系人">
            <span>{{ item.clientContactPerson }}</span>
          </el-form-item>
          <el-form-item label="联系号码">
            <span>{{ item.clientContactPhone }}</span>
          </el-form-item>
          <el-form-item label="经纬度">
            <span>{{ item.clientAddressLongitude }},{{ item.clientAddressLatitude }}</span>
          </el-form-item>
          <el-form-item label="地址信息">
            <span>{{ item.clientAddress }}</span>
          </el-form-item>
          <el-form-item label="详细地址">
            <span>{{ item.clientAddressDetail }}</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import tree from '@/utils/tree'
export default {
  props: {
    status: Array,
    taskList: Array,
    cycleList: Array,
  },
  data() {
    return {
      size: 'small',
      loading: false,
      visible: false,
      detail: {},
      projects: [],
      treeData: [],
      defaultProps: {
        label: 'measureName',
        children: 'children',
        disabled: this.disabledFn
      }
    }
  },
  methods: {
    disabledFn () {
      return true
    },
    async init (row) {
      this.detail = {}
      this.projects = []
      this.treeData = []
      this.visible = true
      this.detail = Object.assign({}, row)
      this.projects = this.detail.projectInfos.map((item) => {
        const config = JSON.parse(item.specificationConfig)
        const measureId = item.scopes.map((measure) => {
          return measure.measureId
        })
        return {
          ...item,
          ...config,
          measureId
        }
      })
      const clientCompanyId = this.detail.clientCompanyId
      const res = await this.$api.electricOperations.getMOViewTreeNodes(clientCompanyId)
      if (res.success) {
        const list = res.data.map((item) => {
          return {
            ...item,
            disabled: true
          }
        })
        this.treeData = tree.creatMeasureTreeJson(list, 0)
      }
      this.$nextTick(() => {
        // console.log(this.$refs.tree)
        for (let i = 0; i < this.$refs.tree.length; i++) {
          this.$refs.tree[i].setCheckedKeys(this.projects[i].measureId)
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.drawer-main {
  color: #333;
  padding: 16px;
  text-align: left;
  .title {
    font-size: 18px;
  }
}

.project {
  margin: 12px 0;
  padding: 12px 0;
  border-bottom: 1px solid #ddd;
}

.el-form-item {
  margin-bottom: 6px;
}

.tree-content {
  ::v-deep .el-checkbox.is-disabled.is-checked {
    color: #409EFF;
    .el-checkbox__inner {
      background-color: #409EFF;
      border-color: #409EFF;
      &::after {
        border-color: #FFF;
      }
    }
  }
}
</style>